(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yakita-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('.yakita-whatsapp');
  if (!link) return;
  const info = link.closest('.product__info-container');
  const variant = info?.querySelector('product-form input[name="id"]')?.value || link.dataset.variantId;
  const price = info?.querySelector('.price--on-sale .price__sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular')?.textContent.trim() || link.dataset.price;
  const url = new URL(link.dataset.productUrl);
  if (variant) url.searchParams.set('variant', variant);
  const message = link.dataset.message.replace('__TITLE__', link.dataset.title).replace('__PRICE__', price).replace('__URL__', url.href);
  link.href = 'https://wa.me/919020191689?text=' + encodeURIComponent(message);
});
  } catch(e) { console.error(e); }
})();

})();
